<script setup lang="ts">
import { getDealer } from '~/services/DealersService'

const route = useRoute()

const dealer = await getDealer(route.params.slug as string)
useHead({
  title: `${dealer?.title}`,
})
</script>

<template>
  <div class="h-full flex justify-between flex-col">
    <div class="container mx-auto px-2 py-20">
      <DealerDetail v-if="dealer" :dealer="dealer" />
    </div>
    <DealersPart2 />
  </div>
</template>
